<div id="main-content" class="page-wrapper" [class]="'layout-with-margin-' + (layoutTypeObservable$ | async)">
    <router-outlet></router-outlet>
</div>
